/* Product page extras: % off pill, order cutoff, frequently bought together. */
(function () {
  var S = window.SITRA || {};
  var root = ((S.routes && S.routes.root) || '/').replace(/\/?$/, '/');
  function $(s, c) { return (c || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return S.money ? S.money(c) : '$' + (c / 100).toFixed(2); }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  var sec = $('[data-product-section]'); if (!sec) return;
  var product = {}; try { product = JSON.parse($('[data-product-json]', sec).textContent); } catch (e) {}
  var idInput = $('[data-product-form] input[name="id"]', sec);
  function curVariant() { var id = idInput && +idInput.value; return (product.variants || []).filter(function (v) { return v.id === id; })[0] || (product.variants || [])[0]; }

  /* % off pill */
  var pill = $('[data-pct-off]', sec), priceEl = $('[data-price]', sec);
  function updPill() {
    var v = curVariant(); if (!pill || !v) return;
    var pct = v.compare_at_price > v.price ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    pill.hidden = pct < 5; pill.textContent = pct + '% OFF';
    renderFbtTotal();
  }
  if (priceEl) new MutationObserver(function () { setTimeout(updPill, 30); }).observe(priceEl, { childList: true, characterData: true, subtree: true });

  /* order cutoff */
  var cut = $('[data-cutoff]', sec);
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w !== 6) n--; } return d; }
  function updCut() {
    if (!cut || !S.delivery) return;
    var now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 999);
    var mins = Math.max(1, Math.floor((end - now) / 60000)), h = Math.floor(mins / 60), m = mins % 60;
    var ship = addBiz(now, S.delivery.pMax || 3).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    $('span', cut).innerHTML = 'Order within <b>' + (h ? h + 'h ' : '') + m + 'm</b> to ship by <b>' + ship + '</b>';
    cut.hidden = false;
  }
  updCut(); setInterval(updCut, 60000);

  /* frequently bought together */
  var fbt = $('[data-fbt]'), list = [], busy = false;
  function sizeChosen() { var s = $('[data-selected-value][data-kind="size"]', sec); return !s || s.textContent.trim() !== 'Select'; }
  function renderFbtTotal() {
    if (!fbt || !list.length) return;
    var t = 0, n = 0;
    list.forEach(function (it, i) {
      var box = fbt.querySelector('[data-fbt-check="' + i + '"]'); if (box && !box.checked) return;
      var v = i === 0 ? curVariant() : it.vs.filter(function (x) { return x.id === +it.sel; })[0];
      if (v) { t += v.price; n++; }
      if (i === 0) { var p = fbt.querySelector('[data-fbt-price="0"]'); if (p && v) p.textContent = money(v.price); }
    });
    $('[data-fbt-total]', fbt).textContent = money(t);
    $('[data-fbt-count]', fbt).textContent = n + ' item' + (n === 1 ? '' : 's') + ' selected';
    var sh = $('[data-fbt-ship]', fbt), bar = $('[data-fbt-bar]', fbt);
    if (sh && S.freeShip) {
      var left = S.freeShip - t;
      sh.innerHTML = n === 0 ? 'Select items to build your bundle' : (left > 0 ? 'Add <b>' + money(left) + '</b> more for free US shipping' : '<b>This bundle ships free</b> in the US');
      if (bar) bar.style.width = Math.min(100, Math.round(t * 100 / S.freeShip)) + '%';
    }
    var btn = $('[data-fbt-add]', fbt);
    if (btn && !busy) { btn.textContent = n > 1 ? 'Add all ' + n + ' to bag' : 'Add to bag'; btn.disabled = n === 0; }
  }
  function renderFbt() {
    var box = $('[data-fbt-items]', fbt);
    box.innerHTML = list.map(function (it, i) {
      var v = i === 0 ? curVariant() : it.vs[0];
      var pick = (i > 0 && it.vs.length > 1) ? '<label class="visually-hidden" for="fbtv' + i + '">Option</label><select id="fbtv' + i + '" data-fbt-variant="' + i + '">' + it.vs.map(function (x) { return '<option value="' + x.id + '">' + esc(x.title) + '</option>'; }).join('') + '</select>' : (i === 0 ? '<span class="fbt__this">This item</span>' : '');
      return '<div class="fbt__item"><label class="fbt__check"><input type="checkbox" data-fbt-check="' + i + '" checked><span class="visually-hidden">Include ' + esc(it.title) + '</span></label>' +
        '<a href="' + esc(it.url) + '" class="fbt__img">' + (it.image ? '<img src="' + esc(img(it.image, 360)) + '" alt="" loading="lazy" width="180" height="240">' : '') + '</a>' +
        '<a href="' + esc(it.url) + '" class="fbt__title">' + esc(it.title) + '</a><div class="fbt__price" data-fbt-price="' + i + '">' + money(v ? v.price : 0) + '</div>' + pick + '</div>';
    }).join('');
    fbt.hidden = false; renderFbtTotal();
  }
  function norm(p) { var vs = (p.variants || []).filter(function (v) { return v.available; }); return { id: p.id, title: p.title, url: p.url, image: p.featured_image || (p.images && p.images[0]), vs: vs, sel: vs[0] && vs[0].id }; }
  if (fbt) {
    list = [{ id: product.id, title: product.title, url: product.url, image: product.featured_image, vs: product.variants || [] }];
    var cur = (fbt.dataset.curated || '').split(',').filter(Boolean);
    var getCurated = Promise.all(cur.map(function (h) { return fetch(root + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }));
    var rec = function (intent) { return fetch(root + 'recommendations/products.json?product_id=' + fbt.dataset.pid + '&limit=8&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; }); };
    getCurated.then(function (a) {
      a = a.filter(Boolean); if (a.length >= 2) return a;
      return rec('complementary').then(function (b) { return b.length >= 2 ? a.concat(b) : rec('related').then(function (c) { return a.concat(b, c); }); });
    }).then(function (ps) {
      var seen = {}; seen[product.id] = 1;
      ps.forEach(function (p) { if (list.length >= 3 || seen[p.id] || !p.available) return; seen[p.id] = 1; var n = norm(p); if (n.vs.length) list.push(n); });
      if (list.length > 1) renderFbt();
    });
    fbt.addEventListener('change', function (e) {
      var s = e.target.closest('[data-fbt-variant]');
      if (s) { var it = list[+s.dataset.fbtVariant]; it.sel = s.value; var v = it.vs.filter(function (x) { return x.id === +s.value; })[0]; var p = fbt.querySelector('[data-fbt-price="' + s.dataset.fbtVariant + '"]'); if (p && v) p.textContent = money(v.price); }
      var c = e.target.closest('[data-fbt-check]'); if (c) c.closest('.fbt__item').classList.toggle('is-off', !c.checked);
      renderFbtTotal();
    });
    fbt.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fbt-add]'); if (!b || busy) return;
      var msg = $('[data-fbt-msg]', fbt); msg.textContent = '';
      var items = [];
      list.forEach(function (it, i) {
        var box = fbt.querySelector('[data-fbt-check="' + i + '"]'); if (box && !box.checked) return;
        items.push({ id: i === 0 ? +idInput.value : +it.sel, quantity: 1 });
      });
      var mainOn = fbt.querySelector('[data-fbt-check="0"]');
      if (mainOn && mainOn.checked && !sizeChosen()) {
        msg.textContent = 'Please choose your size above first.';
        var opt = $('[data-kind="size"].size-btn', sec); if (opt) opt.closest('div').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!items.length || !(S.u && S.u.addToCart)) return;
      busy = true; b.disabled = true; b.textContent = 'Adding…';
      S.u.addToCart(items).catch(function (er) { msg.textContent = (er && (er.description || er.message)) || 'Could not add these items.'; }).then(function () { busy = false; renderFbtTotal(); });
    });
  }
})();